import React from "react";
import { CustomDetailsList, Loader } from "../../../shared";
import { useNavigate } from "react-router-dom";
import { Button, Stack } from "@mui/material";
import { useManageCategorySeo } from "../hooks/useManageCategorySeo";

export const CategorySeoDetails = ({ categoryDetails }) => {
  const navigate = useNavigate();
  const { state, isEditable } = useManageCategorySeo({});

  const columns = React.useMemo(
    () => [
      {
        title: "URL Slug",
        accessor: "slug",
      },
      {
        title: "Meta Title",
        accessor: "meta_title",
      },
      {
        title: "H1 Tag",
        accessor: "header",
      },
      {
        title: "Meta Description",
        accessor: "meta_description",
      },
    ],
    []
  );

  return (
    <React.Fragment>
      {state.isFormDetailsLoading ? (
        <Stack height="300px" justifyContent="center">
          <Loader />
        </Stack>
      ) : (
        <CustomDetailsList
          columns={columns}
          data={state.seoDetails}
          title="SEO"
          headerRightContent={
            isEditable && (
              <Button
                type="button"
                size="medium"
                variant="contained"
                onClick={() => navigate(`seo/edit`, { state: categoryDetails })}
              >
                Edit
              </Button>
            )
          }
        />
      )}
    </React.Fragment>
  );
};
